import {get,post} from './http'
export const listByCode = (code)=>{
    return get('/common/vi/dictionary/listByCode?code='+code);
}
export const getSignature = () => get('/common/v1/file/signature','');